import { SafeUrl } from "@angular/platform-browser";

export class SearchResourceResultDto {
    ResourceId: number;
    GPN: string;
    ResourceName: string;
    ResourceEmail: string;
    GUI: string;
    ResourcePhotoUrl: SafeUrl | null;
}
export class SearchResourceDto {
    SearchKey: string;
    InstanceId: number;
    ResourceId: number;
    ResourceSource: string;
}